import * as React from 'react';

export type PlainMarkdownKind = 'default' | 'secondary';

export const PlainMarkdownContext = React.createContext<null | { kind: PlainMarkdownKind }>(null);

export function PlainMarkdownProvider(props: {
    kind: PlainMarkdownKind;
    children: React.ReactNode;
}): React.ReactElement {
    const { kind, children } = props;
    const value = React.useMemo(() => ({ kind }), [kind]);
    return <PlainMarkdownContext.Provider value={value}>{children}</PlainMarkdownContext.Provider>;
}
